export default __webpack_public_path__ + "static/media/service-request.ca3345c6.png";